export const FETCH_REQUEST = 'transactions/FETCH_REQUEST'
export const FETCH_SUCCESS = 'transactions/FETCH_SUCCESS'
export const FETCH_FAILURE = 'transactions/FETCH_FAILURE'

export const FETCH_SUMMARIES_REQUEST = 'transactions/FETCH_SUMMARIES_REQUEST'
export const FETCH_SUMMARIES_SUCCESS = 'transactions/FETCH_SUMMARIES_SUCCESS'
export const FETCH_SUMMARIES_FAILURE = 'transactions/FETCH_SUMMARIES_FAILURE'

export const UPDATE_REQUEST = 'transactions/UPDATE_REQUEST'
export const UPDATE_SUCCESS = 'transactions/UPDATE_SUCCESS'
export const UPDATE_FAILURE = 'transactions/UPDATE_FAILURE'
